module.exports = __webpack_public_path__ + "img/viber-color.010cd9c1.svg";